module.exports = __webpack_public_path__ + "static/media/nav-home-icon.66968b96.svg";